import script from "./StatsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsSection.vue?vue&type=script&setup=true&lang=js"

import "./StatsSection.vue?vue&type=style&index=0&id=3da4edce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da4edce"]])

export default __exports__